import { call, put, select, takeLatest } from 'redux-saga/effects';
import { LOAD_RECOMMENDATIONS, LOAD_RECOMMENDATIONS_PRODUCTS } from './constants';
import {
  recommendationsLoaded,
  recommendationsLoadingError,
  recommendationsLoadingProductsError,
  recommendationsProductsLoaded
} from './actions';
import { makeSelectCurrentSite, makeSelectCurrentUserToken } from '../App/selectors';
import { authorizedRequest } from '../../request';

/**
 * Most visited articles recommendations for the home stream of a user
 */
export function* getRecommendationsArticles() {
  const token = yield select(makeSelectCurrentUserToken());
  const site = yield select(makeSelectCurrentSite());
  const requestURL = `/widgets/${site}/most_visited_content`;

  try {
    const repos = yield call(authorizedRequest, requestURL, token);
    yield put(recommendationsLoaded(repos));
  } catch (err) {
    yield put(recommendationsLoadingError(err));
  }
}

/**
 * Most visited products recommendations for the home stream of a user
 */
export function* getRecommendationsProducts() {
  const token = yield select(makeSelectCurrentUserToken());
  const site = yield select(makeSelectCurrentSite());
  const requestURL = `/widgets/${site}/most_visited_product`;

  try {
    const repos = yield call(authorizedRequest, requestURL, token);
    yield put(recommendationsProductsLoaded(repos));
  } catch (err) {
    yield put(recommendationsLoadingProductsError(err));
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export function* mostVisitedArticlesRecommendationsData() {
  yield takeLatest(LOAD_RECOMMENDATIONS, getRecommendationsArticles);
}

export function* mostVisitedProductsRecommendationsData() {
  yield takeLatest(LOAD_RECOMMENDATIONS_PRODUCTS, getRecommendationsProducts);
}
